<template>
        <v-container class="mt-3">
            <!-- <v-layout class="align-center justify-centeri">
                <v-flex xs12> -->
                    <div>
                        <v-data-table
                                :headers="headers"
                                :items="staff"
                                :page.sync="page"
                                :items-per-page="5"

                                @page-count="pageCount = $event"
                                class="text-left elevation-1 pa-3 font-weight-regular blue--text text--darken-4"
                        >
                            <template v-slot:item.name="{ item }">
                                <v-list-item @click="viewItem(item)">
                                    <v-list-item-avatar class="text-center" :color="!item.avatar ? 'teal accent-3':''">
                                        <v-img v-if="item.avatar" src="https://cdn.vuetifyjs.com/images/john.png"></v-img>
                                        <span v-else class="mx-auto text-center white--text headline">{{item.name[0]}}</span>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title >{{item.name}}</v-list-item-title>
                                        <v-list-item-subtitle>{{item.occupation}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>

                            <template v-slot:top>
                                <v-toolbar flat color="white">
                                    <v-toolbar-title>Presença</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                        </v-data-table>
                        <div class="text-center pt-2">
                            <v-pagination v-model="page" :length="pageCount"></v-pagination>
                        </div>
                    </div>
        </v-container>

</template>

<script>
    var moment = require('moment')
    export default {
        data: () => ({
            dialog: false,
            page: 1,
            pageCount: 0,
            headers: [
                {text: 'Nome', align: 'start', sortable: false, value: 'name',},
                { text: 'Presença', value: 'presence', sortable: false },
                { text: 'Faltas', value: 'missing', sortable: false },
            ],
            editedIndex: -1,
            editedItem: {
                name: '',
                presence: '',
                missing: ''
            },
            defaultItem: {
                name: '',
                presence: '',
                missing: ''
            },
        }),

        computed: {
            staff(){
                return this.$store.getters.nursingStaff.map((value)=>{
                    let nurse = value
                    nurse.presence = nurse.frequency.filter((value)=>value.present).length
                    nurse.missing = nurse.frequency.filter((value)=>!value.present).length
                    return nurse
                })
            }
        },

        methods: {

            viewItem (item) {
                this.editedIndex = this.staff.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.$store.dispatch('setSelectedNurse',item)
                this.$router.push(`/viewnurse/${this.editedIndex}`)
            },
        },
    }
</script>

<style scoped>

</style>